var baseStyle = function baseStyle(props) {
  var c = props.colorScheme;
  return {
    color: c ? "".concat(c, ".400") : "gray.500",
    fontSize: 'md',
    fontFamily: 'body',
    lineHeight: 'base',
    d: 'inline-block',
    mt: 2
  };
};
var defaultProps = {
  colorScheme: 'red'
};
var Feedback = {
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { Feedback as default };